module.exports = __webpack_public_path__ + "static/media/view3.63a1562b.jpg";